import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Lottie from 'react-lottie';
import landingAnimation from 'assets/animation/landing_animation.json';
import styles from './userHome.styles';

const animationDefaultOptions = {
  loop: true,
  autoplay: true,
  animationData: landingAnimation,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

const BottomAnimation = () => (
  <Box sx={{ ...styles.background }}>
    <Typography variant="h4" align="left" sx={{ ...styles.subtitle }}>
      The simplest way to run quantum
    </Typography>
    <Lottie options={animationDefaultOptions} height={80} width={400} style={{ marginLeft: '0' }} />
  </Box>
);

export default BottomAnimation;
